import { datadogRum } from '@datadog/browser-rum'
import { initDatadogLogs } from '@thyme/libs/src/datadog/logs'
import { initDatadogRum } from '@thyme/libs/src/datadog/rum'
import { getLogger } from '@thyme/libs/src/logging/logger'
import { Config } from '@/libs/config/types'
import { DatadogUser } from './types'

/**
 *
 * @param config
 */
export function initializeDatadog(config: Config) {
  if (!config.datadog.enabled) {
    getLogger().debug('Skipping Datadog initialization...', { foo: 'bar' })
    return
  }

  const { apiUrl } = config

  initDatadogLogs(config.datadog, {
    version: APP_VERSION,
    forwardConsoleLogs: 'all',
    sessionSampleRate: 100,
  })

  initDatadogRum(config.datadog, {
    version: APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'allow',
    // enable collection of additional data
    allowedTracingUrls: [apiUrl, (url) => url.startsWith(apiUrl)],
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    enableExperimentalFeatures: ['clickmap'],
  })

  getLogger().info('Datadog initialized.')
}

/**
 *
 * @param config
 * @param user
 */
export function setDatadogUser(config: Config, user: DatadogUser) {
  if (!config.datadog.enabled) {
    getLogger().debug('Datadog not enabled. Skipping setUser...')
    return
  }

  try {
    datadogRum.setUser(user)
    getLogger().info('Datadog user set.', { user })
  } catch (err) {
    getLogger().error('Failed to set Datadog user.', { error: err })
  }
}

/**
 *
 * @param config
 */
export function clearDatadogUser(config: Config) {
  if (!config.datadog.enabled) {
    getLogger().debug('Datadog not enabled. Skipping clearUser...')
    return
  }

  datadogRum.clearUser()
  getLogger().info('Datadog user cleared.')
}
